import { getSchemaTypeNameByName } from "@tiptap/core";
import { getNodeType, getMarkType } from "@tiptap/react";

export function getSelectedAttributes(state, typeOrName) {
  const schemaType = getSchemaTypeNameByName(
    typeof typeOrName === "string" ? typeOrName : typeOrName.name,
    state.schema
  );

  if (schemaType === "node") {
    return getAttributesForNodes(state, typeOrName);
  }

  if (schemaType === "mark") {
    return getAttributesForMarks(state, typeOrName);
  }

  return [];
}

export function getAttributesForMarks(state, typeOrName) {
  const type = getMarkType(typeOrName, state.schema);
  const { from, to, empty } = state.selection;
  const marks = [];

  if (empty) {
    if (state.storedMarks) {
      marks.push(...state.storedMarks);
    }

    marks.push(...state.selection.$head.marks());
  } else {
    state.doc.nodesBetween(from, to, (node) => {
      marks.push(...node.marks);
    });
  }

  return marks
    .filter((markItem) => markItem.type.name === type.name)
    .map((mark) => ({ ...mark.attrs }));
}

export function getAttributesForNodes(state, typeOrName) {
  const type = getNodeType(typeOrName, state.schema);
  const { from, to } = state.selection;
  const nodes = [];

  state.doc.nodesBetween(from, to, (node) => {
    nodes.push(node);
  });

  return nodes
    .reverse()
    .filter((nodeItem) => nodeItem.type.name === type.name)
    .map((node) => ({ ...node.attrs }));
}
